export default "__VITE_ASSET__fE78JiPL__"